import axios from "../axios";

/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/bidder/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
/**
 * 提交
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const commit = (data) => {
  return axios({
    url: "/bidder/commit",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}
/**
 * 获取会员个人的记录
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getListByDeptId = (data) => {
  return axios({
    url: "/bidder/getListByDeptId",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getRecordById = (data) => {
  return axios({
    url: "/bidder/getRecordById",
    method: 'post',
    data
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/bidder/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
export const downloadAlfxt = (data) => {
  return axios({
    url: '/bidder/downloadAlfxt',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
export const downloadSbs = (data) => {
  return axios({
    url: '/bidder/downloadSbs',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/**
 * 同意招标代理推优申报
 */
export const approveBiddersb = (data) => {
  return axios({
    url: "/bidder/approveBiddersb",
    method: 'post',
    data
  })
}

export const rejectBiddersb = (data) => {
  return axios({
    url: "/bidder/rejectBiddersb",
    method: 'post',
    data
  })
}

export const getBidderpsList = (data) => {
  return axios({
    url: '/bidder/getBidderpsList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getBidderRecordVInfoById = (data) => {
  return axios({
    url: "/bidder/getBidderRecordVoInfoById",
    method: 'post',
    data
  })
}

export const saveBidderPsResult = (data) => {
  return axios({
    url: "/bidder/saveBidderPsResult",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const getSbtjbList = (data) => {
  return axios({
    url: "/bidder/getSbtjbList",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })

}

export const exportSbtjb = (name, data) => {
  return axios({
    url: "/bidder/exportSbtjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


export const getPstjb = (data) => {
  return axios({
    url: "/bidder/getPstjb",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })

}


export const exportPsthb = (name, data) => {
  return axios({
    url: "/bidder/exportPstjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })

}

/**
 * 获取红花杯申报方法 pdf文件
 * @returns {Promise | Promise<unknown>}
 */
export const getBidderpsPDF = () => {
  return axios({
    url: "/bidder/getBidderpsPDF",
    method: 'get',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/bidder.js